/** @format */
import React, { FC } from 'react'
import styled from 'styled-components'

interface DescriptionItemProps {
  className?: string
  label?: string
  span?: number
  children?: React.ReactNode
}

const DescriptionItem: FC<DescriptionItemProps> = ({ className, span, label, children }) => {
  return (
    <div className={`${className} ksc_descriptions_item`}>
      <p className="ksc_descriptions_item_label">{label}</p>
      <div className="ksc_descriptions_item_content">{children}</div>
    </div>
  )
}

export default styled(DescriptionItem)<DescriptionItemProps>`
  width: ${props => (props.span ? `calc(100% / ${props.span})` : '')} !important;
  display: flex;
  padding: 8px 0;
  .ksc_descriptions_item_label {
    color: #848f9a;
    margin-bottom: 0;
    padding-right: 8px;
  }
  .ksc_descriptions_item_content {
    flex: 1;
    word-break: break-all;
  }
`
